import { useState } from 'react';

import toast from 'react-hot-toast';

const useClipboard = () => {
    const [clipboard, setClipboard] = useState(null);
    const copy = (inputValue) => {
        try {
            if (navigator.clipboard) {
                navigator.clipboard
                    .writeText(inputValue)
                    .then(() => toast.success('Copy to clipboard'))
                    .then(() => console.log('Copy success!'));
            } else {
                toast.error('Error writen to the clipboard');
            }
        } catch (error) {
            toast.error('Error writen to the clipboard');
            throw error;
        }
    };
    const past = () => {
        try {
            if (navigator.clipboard) {
                navigator.clipboard.readText().then((result) => {
                    setClipboard(result);
                    return result;
                });
            } else console.log('Copy faild!');
        } catch (error) {
            toast.error('Error reading from the clipboard');
            throw error;
        }
    };
    return { copy, past, clipboard };
};
export { useClipboard };
